export const CRIBL_AGENT_HEADER_NAME = 'X-Cribl-Agent';
export const MAESTRO_AGENT = 'maestro';
export const TYPHON_AGENT = 'typhon';
